import ViewfinderFaceid from './ViewfinderFaceid';

export default ViewfinderFaceid;
